module.exports = __webpack_public_path__ + "img/desktop.a5422294.jpg";